export default __webpack_public_path__ + "static/media/osb-plywood.56c51bfa.gif";